import { Anchor, Badge, Box, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconChartLine, IconHistory } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import TextMessagesStats from './TextMessagesStats';

const TextMessagesCards = ({ textMessages, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const domainCurrency = currentDomain.currency;
  const location = useLocation();

  return textMessages.map((textMessage) => (
    <Card key={textMessage.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Anchor href={`#${location.pathname}/${textMessage.id}/details`} fw={600}>
              {textMessage.name}
            </Anchor>
            <Box>
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(textMessage.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(textMessage.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${textMessage.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <TextMessagesStats stats={stats} textMessage={textMessage} period={period} currency={domainCurrency} />
        </Grid>
      </Card.Section>
    </Card>
  ));
};

export default TextMessagesCards;
